import UsersRoleModel from '../models/UsersRoleModel';

export default {
  data() {
    return {
      navigation: [
        {
          title: this.$t('Dashboard'),
          name: 'Dashboard',
          icon: 'icon-speedometer',
          authorize: [UsersRoleModel.ROLE_SUPERADMIN, UsersRoleModel.ROLE_SHIPNETWORK],
        },
        {
          title: this.$tc('Marketplaces', 2),
          name: 'Marketplaces',
          icon: 'fa fa-shopping-cart',
          authorize: [UsersRoleModel.ROLE_SUPERADMIN],
          children: [
            {
              title: this.$tc('Marketplaces', 2),
              name: 'MarketplacesMarketplaces',
              icon: 'fa fa-shopping-cart',
              authorize: [UsersRoleModel.ROLE_SUPERADMIN],
            },
            {
              title: this.$tc('Categories', 2),
              name: 'MarketplacesCategories',
              icon: 'fa fa-th-list',
              authorize: [UsersRoleModel.ROLE_SUPERADMIN],
            },
          ],
        },
        {
          title: this.$tc('Products', 2),
          name: 'Products',
          icon: 'fa fa fa-shopping-bag',
          authorize: [UsersRoleModel.ROLE_SUPERADMIN],
          children: [
            {
              title: this.$tc('Colors Maps', 2),
              name: 'ProductsColorsMaps',
              icon: 'fa fa-paint-brush',
              authorize: [UsersRoleModel.ROLE_SUPERADMIN],
            },
            {
              title: this.$tc('Sizes Maps', 2),
              name: 'ProductsSizesMaps',
              icon: 'fa fa-arrows',
              authorize: [UsersRoleModel.ROLE_SUPERADMIN],
            },
          ],
        },
        {
          title: this.$tc('Users', 2),
          name: 'Users',
          icon: 'fa fa-user',
          authorize: [UsersRoleModel.ROLE_SUPERADMIN, UsersRoleModel.ROLE_SHIPNETWORK],
          children: [
            {
              title: this.$tc('Accounts', 2),
              name: 'UsersAccounts',
              icon: 'fa fa-users',
              authorize: [UsersRoleModel.ROLE_SUPERADMIN, UsersRoleModel.ROLE_SHIPNETWORK],
            },
            {
              title: this.$tc('Users', 2),
              name: 'UsersUsers',
              icon: 'fa fa-user',
              authorize: [UsersRoleModel.ROLE_SUPERADMIN],
            },
          ],
        },
        {
          title: this.$tc('Plan Managament', 1),
          name: 'PlanManagement',
          icon: 'fa fa-tasks',
          authorize: [UsersRoleModel.ROLE_SUPERADMIN],
          children: [
            {
              title: this.$tc('Custom Plans', 2),
              name: 'CustomPlanManagement',
              icon: 'fa fa-tasks',
              authorize: [UsersRoleModel.ROLE_SUPERADMIN],
            },
            {
              title: this.$tc('Default Plans', 2),
              name: 'DefaultPlanManagement',
              icon: 'fa fa-tasks',
              authorize: [UsersRoleModel.ROLE_SUPERADMIN],
            },
          ],
        },
      ],
    };
  },
};
